import { createSelector } from '@reduxjs/toolkit';

import { searchResponseMessagesSelector } from 'Core/selectors/search.js';
import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig.js';
import {
  createFitmentSearchRequestSelectionSelector,
  createVehicleFromUriSelector,
  selectedVehicleSelector,
  isVehicleSelectedSelector,
} from './index.js';

export const fitmentSearchSelector = (state) => state.fitmentSearch;

const selectedVehicleSelectionSelector = createSelector(
  selectedVehicleSelector,
  (selectedVehicle) => selectedVehicle.selection,
);

export const vehicleSelectionSelector = (state) => {
  const vehicleFromUriSelection = createVehicleFromUriSelector(state);
  if (vehicleFromUriSelection.length) {
    return vehicleFromUriSelection;
  }

  if (fitmentSearchConfig.isFitmentSearchWidgetsVisible) {
    if (isVehicleSelectedSelector(state)) {
      return selectedVehicleSelectionSelector(state);
    }

    return createFitmentSearchRequestSelectionSelector()(state);
  }

  return [];
};

export const isSpecifyDialogOpenedSelector = (state) => fitmentSearchSelector(state).isSpecifyDialogOpened;
export const isVehicleSelectionForcedSelector = (state) =>
  fitmentSearchSelector(state).isVehicleSelectionForced;
export const showVehicleDialogSelector = (state) => fitmentSearchSelector(state).showDialog;

const fieldsSelector = (state) => fitmentSearchSelector(state).fields;
export const fitmentSearchBaseFieldsSelector = (state) => fieldsSelector(state).base;
export const fitmentSearchExtraFieldsSelector = (state) => fieldsSelector(state).extra;
export const fitmentSearchFieldsSelector = createSelector(
  fitmentSearchBaseFieldsSelector,
  fitmentSearchExtraFieldsSelector,
  (base, extra) => [...base, ...extra],
);

export const isNoVehicleSpecificResultsSelector = createSelector(searchResponseMessagesSelector, (messages) =>
  messages.includes('NoVehicleSpecificResults'),
);

export const isNonVehicleProductsMessageSelector = createSelector(
  searchResponseMessagesSelector,
  (messages) => messages.includes('NonVehicleProducts'),
);

export const notFilteredByVehicleSelector = (state) =>
  state.search.request.selection.some((v) => v.field === 'FilterByVehicle' && v.term === 'False');

export const fitmentTableResponseSelector = (state) => fitmentSearchSelector(state).fitmentTableResponse;

const verifyFitmentSelector = (state) => fitmentSearchSelector(state).verifyFitment;
export const verifyFitmentProductIdSelector = (state) => verifyFitmentSelector(state).productId;
export const verifyFitmentFacetsSelector = (state) => verifyFitmentSelector(state).response.facets;
export const verifyFitmentProductSelector = (state) => verifyFitmentSelector(state).response.product;
export const verifyFitmentRequestSelectionSelector = (state) =>
  verifyFitmentSelector(state).request.selection;
